<svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
        d="M45.9103 22C44.8999 10.787 35.4761 2 24 2C11.8497 2 2 11.8497 2 24C2 35.4761 10.787 44.8999 22 45.9103V43.9012C11.8934 42.8978 4 34.3707 4 24C4 12.9543 12.9543 4 24 4C34.3707 4 42.8978 11.8934 43.9012 22H45.9103Z"
        fill="#4338CA" />
</svg>
    
